import { SiteContactPerson } from '../types/pickupSite';

/**
 * 同一站点内、除 exceptIndex 行之外，这个联系方式是否已经登记过。
 *
 * 比较口径与存量清洗脚本（swiftx `docs/plans/pickup-site-2.2-contact-cleanup.sql` §4）一致：
 * **只比去掉首尾空白后的号码本身**，不比姓名、不比国家码、不比分机。
 * 国家码当前表单只给 +1 一个选项，纳入比较只会在它将来放开时制造
 * 「同一个号码因为国家码不同被当成两个人」的歧义。
 *
 * 黑名单区的号码（另一个 Form.List `blacklistContacts`）**不参与比较**：
 * 它们落库时虽同在 contact_person_json，但带 inBlacklist=true，
 * 存量清洗与 AB 维度口径都把这类条目排除在外，这里跟着排除才不会两套标准。
 *
 * 放在 utils/ 而不是组件里：本目录就是本模块放纯函数的地方（abDimensions、siteName、hubTime 同理），
 * 组件里只留 antd 规则的壳。
 */
export const isContactPhoneTaken = (
  rows: SiteContactPerson[] | undefined,
  exceptIndex: number,
  phone: string | undefined,
): boolean => {
  const target = phone?.trim();
  if (!target) return false;
  return (rows || []).some((row, i) => i !== exceptIndex && row?.phone?.trim() === target);
};
